<template>
  <div class="gatewayInput_main"  :class="{'cn':version == '1','ja':version == '1'}">
    <div class="cont_right">
      <div class="table_box">
        <div class="tr">
          <div class="th" style="width: 5rem;">{{ $t('App.gatewayInput.text1') }}</div>
          <div class="th" style="width: 10rem;">{{ $t('App.gatewayInput.text2') }}</div>
          <div class="th" style="width: 15rem;">{{ $t('App.gatewayInput.text3') }}</div>
          <div class="th" :style="{width: version==2?'9rem':'8rem'}" v-if="dataType == 'view'">{{ $t('App.controllerInput.text11') }}</div>
          <!-- <div class="th" style="width: 15rem;">{{ $t('App.gatewayInput.text4') }}</div> -->
          <div class="th" style="width: 20rem;">{{ $t('App.gatewayInput.text11') }}</div>
          <div class="th" style="width: 10rem;">{{ $t('App.gatewayInput.text5') }}</div>
          <div class="th" :style="{width: version==2?'29rem':'24rem'}"></div>
          <div class="th_scrollbar"></div>
        </div>
        <div class="tr_td_box scrollbar_style">
          <div class="tr" v-for="(item, index) in gatewayList" :key="'tr_' + index" @click="textChangeFun($event,item)">
            <div class="td" style="width: 5rem;">
              <span>{{ index + 1 }}.</span>
            </div>
            <div class="td" style="width: 10rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.name">{{ item.name }}</span>
              <el-input class="input1" v-model="item.name" v-if="item.dataType == 'input'"></el-input>
            </div>
            <div class="td" style="width: 20rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.address">{{ item.address }}</span>
              <el-input class="input1" v-model="item.address" v-if="item.dataType == 'input'"></el-input>
            </div>
            <div class="td" :style="{width: version==2?'9rem':'8rem'}" v-if="dataType == 'view'">
              <span class="text" :title="onlineArr[item.online].name">{{onlineArr[item.online].name}}</span>
            </div>
            <div class="td" style="width: 16rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.expirationDate">{{ item.expirationDate }}</span>
              <!-- <el-input class="input1" v-model="item.expirationDate" v-if="item.dataType == 'input'"></el-input> -->
              <el-date-picker
                v-if="item.dataType == 'input'"
                class="date1"
                v-model="item.expirationDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="">
              </el-date-picker>
            </div>
            <!-- <div class="td" style="width: 15rem;">
              <span  class="text" v-if="item.expirationDate">{{ (item.expirationDate.split(' ')[0].split('-')[0]-1+6)+'-'+item.expirationDate.split(' ')[0].split('-')[1]+'-'+item.expirationDate.split(' ')[0].split('-')[2]}}</span>
            </div> -->
            <div class="td" style="width: 10rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.description">{{ item.description }}</span>
              <el-input class="input1" v-model="item.description" v-if="item.dataType == 'input'"></el-input>
            </div>
            <div class="td" :style="{width: version==2?'31rem':'26rem'}">
              <!-- <div class="button" @click="gatewayConfigWhiteListsGet(item)">{{ $t('App.home.text32') }}</div> -->
              <div class="searchBtn" v-if="item.id != -1" style="margin-right: 1rem;" @click="searchDevicesAndGetLists(item)" v-loading="item.searchDevicesLoading">{{ $t('App.home.text33') }}</div>
              <div class="wifiBtn" v-if="item.id != -1" style="margin-right: 1rem;" @click="wificlick(item)" v-loading="item.wifiClickLoading">{{ $t('App.wifi') }}</div>
              <div class="delBtn" @click="gatewayDel(item,index)" v-loading="item.gatewayDelLoading">{{ $t('App.delete') }}</div>
            
            </div>
          </div>
        </div>
      </div>
      
      <div class="foot_box">
        <div class="btn_box">
          <div class="btn3 icon" @click="addDevFun"></div>
          <!-- <div class="btn1" @click="pageTypeFun">{{ $t('App.cancel') }}</div> -->
          <div class="btn1 text" @click="pageTypeFun()">{{$t('App.exit')}}</div>
          <div class="btn1 text" @click="edit()" v-if="dataType == 'view'">{{$t('App.edit')}}</div>
          <div class="btn1 text" @click="calcel()" v-if="dataType == 'edit'">{{$t('App.cancel')}}</div>
          <div class="btn2" v-loading="loading.gatewayAdding" @click="saveDevFun">{{ $t('App.ok') }}</div>
        </div>
      </div>
    </div>
    <div class="dialog_wrap" v-if="devSnListShow">
      <div class="dialog_bg"></div>
      <div class="dialog_box">
        <div class="dialog_top">
          <div class="dialog_title">{{$t('App.gatewayInput.text9')}}</div>
        </div>
        <div class="dialog_cont">
          <el-checkbox class="all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.gatewayInput.text10')}}</el-checkbox>
          <el-checkbox-group v-model="devSnModel" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in devSnList_" :label="city" :key="city">{{city}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="bottom_btn">
          <div class="btn1 text" @click="devSnListClose">{{ $t("App.cancel") }}</div>
          <div class="btn3 text" @click="devSnListAddFun">{{ $t("App.gatewayInput.text12") }}</div>
          <div class="btn2 text" @click="devSnListSave" v-loading="loading.gateway_configWhiteLists">{{ $t("App.ok") }}</div>
        </div>
      </div>
    </div>
    <div class="wifi_wrap" v-if="wifiListShow">
      <div class="wifi_bg"></div>
      <div class="wifi_box">
        <div class="wifi_top">
          <div class="wifi_title">{{ $t('App.gatewayInput.text6') }}</div>
        </div>
        <div class="wifi_cont">
          <el-form ref="wifi_put" :model="wifi_put" label-width="80px">
            <el-form-item :label="$t('App.gatewayInput.text7')">
              <el-input v-model="wifi_put.name "></el-input>
            </el-form-item>
            <el-form-item :label="$t('App.gatewayInput.text8')">
              <el-input v-model="wifi_put.pwd "></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="wifi_btn">
          <div class="btn1 text" @click="wifiListClose()">{{ $t("App.cancel") }}</div>
          <div class="btn2 text" @click="wifiListSave()" v-loading="loading.gateway_wifiWhiteLists">{{ $t("App.ok") }}</div>
        </div>
      </div>
    </div>
    
		<!-- 选择页面 -->
		<el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
			<el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_" :disabled="true">
				<el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
			</el-radio-group>
			<span  slot="footer" class="footer">
				<el-button @click="projectSelection()">{{$t('App.ok')}}</el-button>
			</span>
		</el-dialog>
    
    <!-- 添加白名单 -->
    <el-dialog
      :title="$t('App.gatewayInput.text12')"
      :visible.sync="devSnListAddDialog"
      width="30%">
      <el-form :model="devSnListAddForm" ref="devSnListAddForm">
        <el-form-item :label="$t('App.gatewayInput.text13')" prop="sn" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
          <el-select v-model="devSnListAddForm.sn" placeholder="" multiple filterable allow-create default-first-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="devSnListAddDialog = false">{{$t("App.cancel")}}</el-button>
        <el-button type="primary" @click="devSnListAddSave" v-loading="loading.devSnListAddSave">{{ $t("App.ok") }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
  name: 'gatewayInput',
  data() {
    return {
      wifi_put:{
        name:'',
        pwd:''
      },
      wifiName:'',
      wifiPwd:'',
      networkAddress:'',
      wifiSnList_:[],
      wifiSnModel:[],
      dataType: 'view',
      formArr: [],
      groupOptions: [],

      gatewayList:[],
      gatewayList_:[],
      lightGatewayarr_:[],

      devSnListShow: false,
      checkAll: false,
      wifiListShow:false,
      devSnModel: [],
      devSnList: [],
      devSnList_: [],
      isIndeterminate: true,
      gatewayId:'',
      onlineArr:[],

			selectVisible: false,
			getUserSettingInfoDateValue_:'systemSetting',
			getUserSettingInfoDate :{
				sysStatus:'',
				projectStatus:'',
				gatewayStatus:'',
				deviceStatus:'',
				groupStatus:'',
				sceneStatus:'',
				scheduleStatus:'',
			},

      devSnListAddDialog:false,
      devSnListAddForm:{
        sn:[]
      },

      loading:{
        gatewayAdding:false,
        gateway_configWhiteLists:false,
        gateway_wifiWhiteLists:false,
        devSnListAddSave:false,
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      client_key: 'client_key',
      username: 'username',
      version: 'version',

      projectId: 'projectId',

      remRatio: 'remRatio',
      updateRemRatio: 'updateRemRatio',
      projectUpdate:'projectUpdate',

      countryId: 'countryId',
      provinceId: 'provinceId',
      cityId: 'cityId',
      hotelId: 'hotelId',
      headerIdStr: 'headerIdStr',
      themeType: 'themeType',
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy() {
  },
  mounted() {
    // this.formArr = [
    //   { name: '', id: '', warrantyPeriod: '', remark: '', dataType: 'text' },
    //   { name: '', id: '', warrantyPeriod: '', remark: '', dataType: 'text' },
    //   { name: '', id: '', warrantyPeriod: '', remark: '', dataType: 'text' },
    //   { name: '', id: '', warrantyPeriod: '', remark: '', dataType: 'text' },
    //   { name: '', id: '', warrantyPeriod: '', remark: '', dataType: 'text' },
    // ]
    this.getUserSettingInfo();
    if(this.projectId){
      this.gatewayListGet()
    }
    this.onlineArr = [
      { id:'0', name: this.$t('App.home.lightOnline0')},
      { id:'1', name: this.$t('App.home.lightOnline1')},
    ];
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
		confirmSelection() {
      this.getUserSettingInfo(data => {
        if (data.isTrue) {
          this.selectVisible = true;
        }
      });
		},
		projectSelection(){
			this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
			this.selectVisible = false;
		},
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
				username: this.username,
				version: this.version,
				token:this.token,
				},
				{},
				data => {
          this.getUserSettingInfoDate = data.data;
          data.isTrue = false;
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDateValue_ = 'systemSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.projectStatus == 0){
            this.getUserSettingInfoDateValue_ = 'projectSettings'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.getUserSettingInfoDateValue_ = 'gatewayInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.getUserSettingInfoDateValue_ = 'controllerInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.groupStatus == 0){
            this.getUserSettingInfoDateValue_ = 'groupSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.sceneStatus == 0){
            this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.getUserSettingInfoDateValue_ = 'schedule'
            data.isTrue = true
          }
          if(callback){
            callback(data)
          }
				},
				this
			)
		},
    // handleOutsideClick(event) {
    //   if (this.wifiListShow &&!event.target.classList.contains('wifi_wrap')) {
    //     this.wifiListShow = false;
    //   }
    // },
    // 获取WIFI账号密码
    wificlick(obj){
      if(obj.wifiClickLoading){
        return
      }
      
      // this.networkAddress=this.networkAddress;
      this.gatewayAddress = obj.address
      console.log(this.gatewayAddress,'--9--0--0000000')
      this.wifiListShow=true;
      base.ajax_post(
        allUrl.gateway.getWifiInfo,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          networkAddress:obj.address
        },
        {},
        (data) => {
          this.wifi_put.name=data.data.wifiName;
          this.wifi_put.pwd=data.data.wifiPwd;
          this.wifiClickLoading=false;
          console.log(data,'this.wifiClickLoading')
        },
        this,()=>{
        // console.log('Error occurred:', error);
        this.wifiClickLoading = false;
        }
      )
    },


    // 设置wifi账号密码
    wifiListSave(){
      if(this.loading.gateway_wifiWhiteLists){
        return
      }
      // this.gatewayAddress = this.address
      this.loading.gateway_wifiWhiteLists = true;
      base.ajax_post(
        allUrl.gateway.setWifiInfo,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          networkAddress:this.gatewayAddress,
          wifiName:this.wifi_put.name,
          wifiPwd:this.wifi_put.pwd,
        },
        {},
        (data) => {
          this.wifiListShow = false;
              this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
            });
          this.loading.gateway_wifiWhiteLists = false;
        },
        this,()=>{
            this.loading.gateway_wifiWhiteLists = false;
          }
      )
    },


    wifiListClose(){
      this.wifiListShow=false;
    },
    //删除网关
    gatewayDel(obj,index) {
      if(obj.gatewayDelLoading){
        return
      }
      this.gatewayId = obj.id;
      this.gatewayDelLoading = true;
      if(obj.id != -1){
        this.$confirm(this.$t('App.message.text24'), this.$t('App.message.text4'), {
          confirmButtonText: this.$t('App.message.text5'),
          cancelButtonText: this.$t('App.message.text6'),
          type: 'warning'
        }).then(() => {
          base.ajax_post(
            allUrl.gateway.gateway_del,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              id: obj.id,
            },
            {},
            (data) => {
              // this.gatewayListGet();
              this.$message({
                showClose: true,
                message: data.msg,
                type: "success",
              });
              this.gatewayListGet();
              obj.gatewayDelLoading = false;
            },
            this,()=>{
              obj.gatewayDelLoading = false;
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.version === '1' ? '已取消删除' : 'Canceled'
          });
        });

      } else{

        this.gatewayList.splice(index, 1)
        // this.gatewayList_.splice(index, 1)
      }
    },
    handleCheckAllChange(val) {
      this.devSnModel = val ? this.devSnList_ : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.devSnList_.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.devSnList_.length;
    },
    devSnListClose(){
      this.devSnListShow = false;
    },
    devSnListAddFun(){
      this.devSnListAddDialog = true;
      this.devSnListAddForm.sn = []
    },
    devSnListAddSave(){
      // this.devSnListAddForm.sn
      this.$refs['devSnListAddForm'].validate((valid) => {
        if (valid) {
          if(this.loading.devSnListAddSave){
            return
          }
          this.loading.devSnListAddSave = true;
          base.ajax_post(
            allUrl.gateway.addWhiteLists,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              projectId: this.projectId,
              addresses:this.devSnListAddForm.sn.join(','),
              networkAddress:this.gatewayAddress,
            },
            {},
            (data) => {
              this.loading.devSnListAddSave = false;
              this.$message({
                showClose: true,
                message: data.msg,
                type: "success",
              });
              // this.getGatewayWhiteLists({id:this.gatewayId,address:this.gatewayAddress})
              this.devSnListAddDialog = false;
            },
            this,()=>{
              this.loading.devSnListAddSave = false;
            }
          )
        }
      });
    },
    //编辑白名单
    devSnListSave(){
      if(this.loading.gateway_configWhiteLists){
        return
      }
      let addresses = '';
      for(let val of this.devSnModel){
        if(addresses == ''){
          addresses = val;
        }else{
          addresses += ','+val;
        }
      }
      for(let val of this.devSnList){
        if(addresses == ''){
          addresses = val;
        }else{
          addresses += ','+val;
        }
      }
      this.loading.gateway_configWhiteLists = true;
      base.ajax_post(
        allUrl.gateway.saveWhiteLists,
        {
          username: this.username,
          version: this.version,
          token: this.token, 
          addresses:addresses,
          networkAddress:this.gatewayAddress,
          projectId: this.projectId,
        },
        {},
        (data) => {
          this.loading.gateway_configWhiteLists = false;
          this.devSnListShow = false;
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          this.loading.gateway_configWhiteLists = false;
        }
      )
    },
    //搜索未配网设备和获取白名单
    searchDevicesAndGetLists(obj){
      if(obj.searchDevicesLoading){
        return
      }
      this.gatewayId = obj.id;
      this.gatewayAddress = obj.address
      obj.searchDevicesLoading = true;
      this.devSnList_ = [];
      this.devSnModel = [];
      base.ajax_post(
        allUrl.gateway.searchDevicesAndGetLists,
        // allUrl.gateway.searchDevices,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id:obj.id,
        },
        {},
        (data) => {
          // console.log(data.data)
          this.devSnList = []
          for(let d of data.data){
            if(data.data.type == 0||data.data.type == 4||data.data.type == 10){
              continue
            }
            // this.devSnList_.push(d.address)
            if(d.netStatus == 0){
              // console.log()
              this.devSnList_.push(d.address)
            }else{
              this.devSnList.push(d.address)
              
            }
          }

          this.searchLists = data.data
          // const searchLists_ = this.searchLists.filter(item => item.netStatus === 0);
          // console.log(searchLists_,'--1----8')
          
          // this.devSnList = this.devSnList_;
          this.devSnListShow = true;
          obj.searchDevicesLoading = false;
        },
        this,()=>{
          obj.searchDevicesLoading = false;
        }
      )
    },
    //获取白名单
    getGatewayWhiteLists(obj){
      if(obj.searchDevicesLoading){
        return
      }
      this.gatewayId = obj.id;
      this.gatewayAddress = obj.address
      obj.searchDevicesLoading = true;
      this.devSnList_ = [];
      this.devSnModel = [];
      base.ajax_post(
        allUrl.gateway.getGatewayWhiteLists,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id:obj.id,
        },
        {},
        (data) => {
          // console.log(data.data)
          
          for(let d of data.data){
            this.devSnList_.push(d.address)
            if(d.netStatus == 1){
              this.devSnModel.push(d.address)
            }
          }
          this.searchLists = data.data
          console.log(this.searchLists,'--1--5--9')
          this.devSnList = this.devSnList_;
          this.devSnListShow = true;
          // this.devSnList_ = data.data
          obj.searchDevicesLoading = false;
        },
        this,()=>{
          obj.searchDevicesLoading = false;
        }
      )
    },
    //组网
    gatewayConfigWhiteListsGet(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      console.log(d,'-5656-')
      base.ajax_post(
        allUrl.gateway.gateway_configWhiteLists,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          ...d
          // name:d.name
        },
        {},
        (data) => {
          for(let d of this.gatewayList){
            d.dataType = 'text'
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      )
    },
    edit(){
      this.dataType = 'edit';
      for(let d of this.gatewayList){
        d.dataType = 'input';
      }
    },
    calcel(){
      this.dataType = 'view';
      for(let d of this.gatewayList){
        d.dataType = 'text';
      }
    },
    textChangeFun(e,obj) {
      console.log(obj)
      // if(obj.dataType == 'input'&&e.target.nodeName!='INPUT'){
      //   obj.dataType = 'text';
      // }
    },
    groupChange(groupArr) {
      // console.log(groupArr)
      // let isTrue = false;
      let arr = [];
      // let group = obj.group[obj.group.length-1]
      let i = 0;
      for (let group of groupArr) {
        arr[i] = false;
        console.log(group, this.groupOptions)
        for (let d of this.groupOptions) {
          if (d.id == group) {
            // isTrue = true
            arr[i] = true;
          }
        }
        i++
      }
      console.log(arr)
      for (let index in arr) {
        if (!arr[index]) {
          this.groupOptions.push({ id: groupArr[index], name: groupArr[index] })
        }
      }
      console.log(this.groupOptions)
    },
    pageTypeFun () {
      this.$emit('pageTypeFun', '')
    },
    //退出登录
    logOut(){
      this.$confirm(this.$t('App.message.text41'), this.$t('App.message.text4'), {
        confirmButtonText: this.$t('App.message.text5'),
        cancelButtonText: this.$t('App.message.text6'),
        type: 'warning'
      }).then(() => {
        base.ajax_post(
        allUrl.login.logout,
        {
          username: this.username,
          clientType: this.os,
          token: this.token,
          version: this.version,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this)
        
        localStorage.clear()
        window.sessionStorage.clear()
        this.$router.push('/login')

      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('App.message.text52')
        });
      });
    },
    addDevFun(){
      this.$set(this.gatewayList,this.gatewayList.length,{
        id:'-1',
        dataType:'input',
        name:'',
        address:'',
        expirationDate:'',
        description:'',
        online:0,
      })
      this.$set(this.gatewayList_,this.gatewayList_.length,{
        id:'-1',
        dataType:'input',
        name:'',
        address:'',
        expirationDate:'',
        description:'',
        online:0,
      })
    },
    saveDevFun(){
      // let list = [];
      console.log(this.gatewayList)
      // dataType
      let gatewayList = JSON.parse(JSON.stringify(this.gatewayList));
      let gatewayList_ = JSON.parse(JSON.stringify(this.gatewayList_));

      for(let key in gatewayList){
        delete gatewayList[key].dataType;
        delete gatewayList_[key].dataType;
        if(gatewayList[key].id == '-1'){
          this.gatewayAdd(gatewayList[key])
          // this.gatewayListGet();
          continue;
        }
        console.log(JSON.stringify(gatewayList[key]),JSON.stringify(gatewayList_[key]))
        if(JSON.stringify(gatewayList[key]) != JSON.stringify(gatewayList_[key])){
          this.gatewayUpdate(gatewayList[key])
          // this.gatewayListGet();
        }
      }
    },
    gatewayListGet() {
      base.ajax_post(
        allUrl.gateway.gateway_gatewayList,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId
        },
        {},
        data => {
          console.log(data)
          for(let d of data.data){
            d.dataType = 'text'
            this.$set(d,'searchDevicesLoading',false);
            this.$set(d,'gatewayDelLoading',false);
          }
          this.gatewayList = data.data;
          this.gatewayList_ = JSON.parse(JSON.stringify(data.data));
          console.log(this.gatewayList)
          // this.lightGatewayarr_ = [];
          // this.gatewayList.forEach((item) => {
          //   console.log(item,'9-9-9-')
          //   if(item.gatewayId){
          //     if(this.lightGatewayarr_[item.gatewayId]){
          //       this.lightGatewayarr_[item.gatewayId] = this.lightGatewayarr_[item.gatewayId] + ',' + item.id;
          //     }else{
          //       this.lightGatewayarr_[item.gatewayId] = item.id
          //     }
          //   }
          // });
        },
        this
      )
    },
    gatewayAdd(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      delete d.id;
      delete d.dataType;
      this.loading.gatewayAdding = true;
      base.ajax_post(
        allUrl.gateway.gateway_add,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.confirmSelection()
          }
          for(let d of this.gatewayList){
            d.dataType = 'text'
          }
          this.gatewayList_ = this.gatewayList;
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.loading.gatewayAdding = false;
          this.gatewayListGet();
          this.$store.commit('projectUpdateFun', {
            projectUpdate: this.projectUpdate+1,
          })
        },
        this, () => {
          this.loading.gatewayAdding = false;
        }
      )
    },
    gatewayUpdate(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      base.ajax_post(
        allUrl.gateway.gateway_update,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          for(let d of this.gatewayList){
            d.dataType = 'text'
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.gatewayListGet();
          // console.log(this.gatewayList)
        },
        this
      )
    },
    // linkToFun(val,data){
    // }
  },
  watch: {
    projectId:function(){
      this.gatewayListGet();
    }
    // updateRemRatio:function(){
    // }
  }
}
</script>

<style type="text/css" lang="less">
// .ratio_1920_1080 {
  .gatewayInput_main {
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    // justify-content: end;
    justify-content: flex-end;
    // &.ja{
    //   .cont_right{
    //     .table_box{
    //       .delBtn{
    //         width: initial;
    //         padding: 0 0.5rem;
    //       }
    //     }
    //   }
    // }
    .cont_right {

      // margin-left: auto;
      // position: absolute;
      // top: 0;
      // right: 0;
      .table_box {
        height: calc(100% - 9rem);
        background: rgba(244, 251, 253, 0.9);
        opacity: 0.9;
        // width: 76.31rem;
        .tr_td_box {
          height: calc(100% - 4.14rem);

          .text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            
          }
          // .button {
          //   border-radius: 0.2rem;
          //   border: 1px solid #3A636F;
          // }
          // width: calc(100% - 0.5rem);
        }

        .date1 {
          width: calc(100% - 1rem);
          height: 3.5rem;
          line-height: 3.5rem;

          .el-input__inner {
            padding-left: 2rem;
            padding-right: 0.5rem;
            width: 100%;
            height: 3.5rem !important;
            line-height: 3.5rem;
            border: 0.09rem solid #3a636f;
            border-radius: 0.44rem;
            background-color: rgba(0, 0, 0, 0);

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }
        }

        .input1 {
          width: calc(100% - 1rem);
          height: 3.5rem;
          line-height: 3.5rem;

          .el-input__inner {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            width: 100%;
            height: 3.5rem !important;
            line-height: 3.5rem;
            border: 0.09rem solid #3a636f;
            border-radius: 0.44rem;
            background-color: rgba(0, 0, 0, 0);

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }

          .el-select__tags {
            .el-tag--small {
              height: 2.5rem;
              line-height: 2.5rem;
              padding: 0 0.5rem;
              max-width: 7rem;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
            }
          }

          .el-select__input {
            // padding-left: 0.5rem;
            width: 100%;
            height: 3.5rem;
            line-height: 3.5rem;
            // border: 0.09rem solid #3A636F;
            // border-radius: 0.44rem;
            background-color: rgba(0, 0, 0, 0);

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }

          .el-input__prefix {
            width: 1.8rem;
            height: 1.8rem;
            top: 0.96rem;
            left: 0.79rem;

            .icon {
              width: 100%;
            }
          }

          .el-input__suffix {
            height: 3.5rem;
            line-height: 3.5rem;
            right: 1.49rem;
          }

          .span {
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            position: relative;
            top: -0.2rem;
          }

          .el-input .el-select__caret {
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .tr {
          display: flex;
          align-items: center;
          height: 4.12rem;
          line-height: 4.12rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          // background: rgba(244, 251, 253, 0.9);
          // background: rgba(255, 255, 255, 1);
          // opacity: 0.8;
          &:nth-child(2n + 1) {
          // background: rgba(255, 255, 255, 1);
            background: rgba(244, 251, 253, 1);
            opacity: 0.9;
          }
          // &:nth-child(2n) {
          //   background: rgba(255, 255, 255, 1);
          //   opacity: 0.8;
          //   // background: rgba(244, 251, 253, 1);
          // }

          .th:nth-child(1),
          .tr:nth-child(1) {
            text-align: left;
          }

          .th,
          .td {
            text-align: center;
            height: 4.12rem;
            line-height: 4.12rem;
            display: flex;
            align-items: center;
            white-space:nowrap;
            justify-content: space-around;
          }

          // .flex_2 {
          //   flex: 2;
          // }
          .td {
            cursor: pointer;
            
            &:nth-child(1) {
              padding-left: 1rem;
            }
          }

          .th {
            &:nth-child(1) {
              padding-left: 1rem;
            }
          }

          .th_scrollbar {
            width: 0.5rem;
            height: 100%;
          }

          // .th{
          // }
          // .td{
          // }
        }
        
        .searchBtn {
          text-align: center;
          min-width: 9.5rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #3A636F;

          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3A636F;
          cursor: pointer;
        }
        .wifiBtn {
          text-align: center;
          min-width: 5.5rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #3A636F;

          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3A636F;
          cursor: pointer;
        }
        .delBtn {
          text-align: center;
          min-width: 5.5rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #3A636F;

          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3A636F;
          cursor: pointer;
        }

      }

      .foot_box {
        height: 9rem;
        // background: rgba(244, 251, 253, 0.9);
        background: #F4FBFD;
        opacity:0.9;
        // padding-left: 30rem;
        display: flex;
        justify-content: flex-end;

        .btn_box {
          display: flex;
          align-items: center;
        }

        .btn1 {
          text-align: center;
          min-width: 7.5rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #3A636F;

          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3A636F;
          margin-right: 5rem;
          cursor: pointer;
        }

        .btn2 {
          text-align: center;
          min-width: 7rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #00C6FF;

          background: #00C6FF;

          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #FFFFFF;
          margin-right: 7rem;
          cursor: pointer;
        }

        .btn3.icon {
          margin-right: 5rem;
          cursor: pointer;
          width: 4.28rem;
          height: 4.28rem;
          background-image: url(../img/icon/btn_bg1.png);
          background-position: center;
          background-size: 100% 100%;
        }
      }
    }
    .wifi_wrap{
       position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      .wifi_bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
      }
      .wifi_box{
        position: relative;
        width: 60%;
        height: 50%;
        background: rgba(244, 251, 253, 0.8);
        border-radius: 0.44rem;
          .wifi_top{
            height: 3rem;
            line-height: 3rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            padding-left: 1rem;
          }
          .wifi_cont{
            padding: 3rem 2rem 1rem 1rem;
            .el-input{
              width:98%;
            }
          }
          .wifi_btn{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 3rem 2rem;
            .btn1{
              width: 7.43rem;
              height: 3.13rem;
              line-height: 3.13rem;
              text-align: center;
              background: #f4fbfd;
              border: 0.09rem solid #3a636f;
              border-radius: 0.26rem;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
              cursor: pointer;
            }
            .btn2{
              width: 7.43rem;
              height: 3.13rem;
              line-height: 3.13rem;
              text-align: center;
              background: rgba(0, 198, 255, 1);
              border: 0px solid #3a636f;
              border-radius: 0.26rem;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #ffffff;
              cursor: pointer;
            }
          }
        }
      }
    
    .dialog_wrap{
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      .dialog_bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
      }
      .dialog_box{
        position: relative;
        width: 60%;
        height: 60%;
        background: rgba(244, 251, 253, 0.8);
        border-radius: 0.44rem;
        .dialog_top{
          height: 3rem;
          line-height: 3rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          padding-left: 1rem;
        }
        .dialog_cont{
          padding: 2rem;
          height: calc(100% - 7rem);
          // .all{
          // }
          .el-checkbox{
            .el-checkbox__label{
              margin-bottom: 1rem;
              font-size: 1.8rem;
              font-weight: normal;
              color: #3a636f;
            }
          }
        }
      }
      
      .bottom_btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 2rem;
        .btn1 {
          width: 7.43rem;
          height: 3.13rem;
          line-height: 3.13rem;
          text-align: center;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
        }

        .btn2 {
          width: 7.43rem;
          height: 3.13rem;
          line-height: 3.13rem;
          text-align: center;
          background: rgba(0, 198, 255, 1);
          border: 0px solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
        }
        .btn3{
          // width: 7.43rem;
          padding: 0 1rem;
          height: 3.13rem;
          line-height: 3.13rem;
          text-align: center;
          background: rgba(0, 198, 255, 1);
          border: 0px solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;

        }
      }
    }
  }
  // .gatewayInput_main.themeType_1{
  //   .cont_right{
  //     .table_box {
  //       background: rgba(250,  237, 218, 0.9);
  //       .date1 {
  //         .el-input__inner {
  //           border: 0.09rem solid #682411;
  //           background-color: rgba(0, 0, 0, 0);
  //           color: #682411;
  //         }
  //       }
  //       .input1 {
  //         .el-input__inner {
  //           border: 0.09rem solid #682411;
  //           background-color: rgba(0, 0, 0, 0);
  //           color: #682411;
  //         }
  //       }
  //       .tr {
  //         color: #682411;
  //         &:nth-child(2n + 1) {
  //           background: rgba(250, 237, 218, 0.9);
  //           opacity: 0.9;
  //         }
  //         .searchBtn {
  //           background: #f2cd9b;
  //           border: 0.1rem solid #682411;
  //           color: #682411;
  //         }
  //         .wifiBtn {
  //           background: #f2cd9b;
  //           border: 0.1rem solid #682411;
  //           color: #682411;
  //         }
  //         .delBtn {
  //           background: #f2cd9b;
  //           border: 0.1rem solid #682411;
  //           color: #682411;
  //         }
  //       }
        
  //     }
  //     .foot_box {
  //       background: #faedda;
  //       .btn3 {
  //         background-image: url(../img/orange/btn_bg1.png);
  //       }
  //       .btn1 {
  //         background: #f2cd9b;
  //         border: 0.1rem solid #682411;
  //         color: #682411;
  //       }
  //       .btn2 {
  //         background: #f44336;
  //         border: 0.09rem solid #f44336;
  //         color: #ffffff;
  //       }
  //     }
  //   }
  //   .wifi_wrap{
  //     .wifi_box{
  //       background: rgba(250, 237, 218, 0.9);
  //       .wifi_top{
  //         color: #682411;
  //       }
  //       .wifi_cont {
  //         .el-form-item__label,.el-input__inner{
  //           color: #682411;
  //         }
          
  //       }
  //       .wifi_btn{
  //         .btn1{
  //           background: #f2cd9b;
  //           border: 0.1rem solid #682411;
  //           color: #682411;
  //         }
  //         .btn2{
  //           background: #f44336;
  //           border: 0.09rem solid #f44336;
  //           color: #ffffff;
  //         }
  //       }
  //     }
  //   }
  //   .dialog_wrap{
  //     .dialog_box{
  //       background: rgba(250, 237, 218, 0.9);
  //       .dialog_top{
  //         color: #682411;
  //       }
  //       .dialog_cont{
  //         .el-checkbox{
  //           .el-checkbox__label{
  //             color: #682411;
  //           }
  //         }
  //       }
  //     }
  //     .dialog_cont {
  //       .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  //         background-color: #e09259;
  //         border-color: #e09259;
  //       }
  //     }
  //     .bottom_btn {
  //       .btn1 {
  //         background: #f2cd9b;
  //           border: 0.1rem solid #682411;
  //           color: #682411;
  //       }

  //       .btn2 {
  //         background: #f44336;
  //         border: 0.09rem solid #f44336;
  //         color: #ffffff;
  //       }
  //       .btn3{
  //         background: #f44336;
  //         border: 0.09rem solid #f44336;
  //         color: #ffffff;

  //       }
  //     }
  //   }
  // } 
// }
</style>